export var compKey = 'simple-audio-player';
//# sourceMappingURL=key.js.map